import config from "config";
import { OktaAuth, OktaAuthOptions } from "@okta/okta-auth-js";

import { transformAuthState } from "services/oktaAuthState";

const {
  auth: { issuer, clientId },
} = config.get();

interface Heap {
  load: (id: string) => void;
  identify: (id: string) => void;
  addUserProperties: (props: object) => void;
  track: (event: string, properties?: Record<string, any>) => void;
}

// rely on interface merging to extend the window object
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    heap: Heap;
  }
}

const oktaConfig: OktaAuthOptions = {
  issuer,
  clientId,
  redirectUri: `${window.location.origin}/login/callback`,
  // extra requirement: user must have valid Okta SSO session
  transformAuthState,
  decodeAccessTokens: true,
};
export const oktaAuth = new OktaAuth(oktaConfig);
